export default __webpack_public_path__ + "static/media/WhatsApp Image 2022-11-30 at 16.54.38 - ARYAN SHARMA.a4d04eab.jpeg";